import React, { Fragment } from 'react';
import { useStore } from 'modules/Stores';
import { observer } from 'mobx-react';
import { OrderReviewModal } from '../OrderReviewModal/OrderReviewModal';

const OrderReviewOptions: OrderReviewState[] = ['true', 'false'];

const OrderReviewModalContainer = () => {
  const {
    isOrderReviewEnabled,
    setOrderReview,
    toggleModal,
    modalsConfig: { orderReview },
  } = useStore('AppStore');

  return orderReview ? (
    <OrderReviewModal
      onClose={() => toggleModal('orderReview')}
      handleSave={order => setOrderReview(order)}
      OrderReviewOptions={OrderReviewOptions}
      defaultValue={isOrderReviewEnabled}
    />
  ) : (
    <Fragment />
  );
};

export default observer(OrderReviewModalContainer);
